"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Destination = exports.Origin = void 0;
/**
 * Origin specifies where the event came from.
 */
var Origin;
(function (Origin) {
    Origin["Form"] = "form";
    Origin["Site"] = "site";
    Origin["Metric"] = "metric";
    Origin["Calc"] = "calc";
})(Origin = exports.Origin || (exports.Origin = {}));
/**
 * Destination specifies event destination.
 */
var Destination;
(function (Destination) {
    Destination["Kafka"] = "kafka";
    Destination["GoogleAnalytics"] = "ga";
})(Destination = exports.Destination || (exports.Destination = {}));
